<template>
  <div id="app">

    <!-- <TheHeader class="hd" /> -->
    <router-view class="main"/>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
.el-loading-mask{
    background-color: rgba(255, 255, 255, 0.7) !important;
}
</style>
